import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { useBilling } from '@/components/Billing/Billing.composables';
//@ts-ignore
import UpgradeRequiredIndicator from '@/components/Billing/UpgradeRequiredIndicator.vue';
import BillingService from '@/components/Billing/billing-service';
import { FeatureTypes } from '@/components/Billing/billing-types';
import { capitalizeWord } from '@/utils/language-service';


export default /*#__PURE__*/_defineComponent({
  __name: 'MaybeUpgradeRequiredIndicator',
  props: {
    billingFeatureId: null
  },
  setup(__props: any) {

const props = __props as { billingFeatureId: FeatureTypes }

// todo:
// try pass the feature id and the minimalPlanNameToUse to the indicator component from here
const { usePlanById, useUpNextRequiredPlanToUse, useHasCapability } = useBilling();
const hasCapability = useHasCapability();
const upNextRequiredPlanToUse = useUpNextRequiredPlanToUse();
const planById = usePlanById();


const isUpgradeRequired = computed(() => !hasCapability.value(props.billingFeatureId));

const minimalPlanIdToUse = computed(() => upNextRequiredPlanToUse.value(props.billingFeatureId));
const minimalPlanToUse = computed(() => planById.value(minimalPlanIdToUse.value));
const minimalPlanNameToUse = computed(() =>
	minimalPlanToUse.value ? capitalizeWord(BillingService.getPlanGroup(minimalPlanToUse.value)) : ''
);
const openUpgradeDialog = (e: unknown) => {
	if (isUpgradeRequired.value) {
		UpgradeRequiredIndicator.setup().openUpgrade(e, props.billingFeatureId);
	}
};

return { __sfc: true,usePlanById, useUpNextRequiredPlanToUse, useHasCapability, hasCapability, upNextRequiredPlanToUse, planById, props, isUpgradeRequired, minimalPlanIdToUse, minimalPlanToUse, minimalPlanNameToUse, openUpgradeDialog, UpgradeRequiredIndicator }
}

})